import type { ObservationEntity } from "./observation.type";

export const getObservationTitle = (observation?: ObservationEntity) => {
  const { id, name } = observation ?? {};
  return id ? `${name} - ${id}` : "";
};
